import { render, staticRenderFns } from "./createTest.vue?vue&type=template&id=0436141b"
import script from "./createTest.vue?vue&type=script&lang=js"
export * from "./createTest.vue?vue&type=script&lang=js"
import style0 from "./createTest.vue?vue&type=style&index=0&id=0436141b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports